import React from "react"
import { dmaeLogo } from "./sub-navigation.module.scss"
import DMAEIcon from "../../assets/svg/dmae-logo.inline.svg"
import { Link } from "gatsby"

const SubNavBegin = () => {
  return (
      <Link to="/" className="navbar-brand">
        <DMAEIcon
          className={`${dmaeLogo} d-none d-sm-block`}
          viewBox="0 0 240 32"
        />
      </Link>
  )
}
export default SubNavBegin
